import React from 'react';
import { useHistory } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Button, EmptyStateView } from '@atlas/ui';

import MISSIONS_TRANSLATION_KEYS from 'components/Smartico/translationsKeys';

const SmarticoMissionsEmptyState = () => {
  const history = useHistory();

  const handleGoToCasino = () => {
    history.push(SiteConfigManager.getComponentPath(COMPONENT_TYPES.CASINO));
  };

  return (
    <EmptyStateView
      className="missions-empty-state"
      dataId="missions-empty-state"
      description={MISSIONS_TRANSLATION_KEYS.MISSIONS_EMPTY_SUBTITLE}
      title={MISSIONS_TRANSLATION_KEYS.MISSIONS_EMPTY_TITLE}
    >
      <Button
        className="big"
        data-testid="go-to-casino"
        label={MISSIONS_TRANSLATION_KEYS.MISSIONS_EMPTY_GO_TO_CASINO}
        onClick={handleGoToCasino}
        type="primary"
      />
    </EmptyStateView>
  );
};

export default SmarticoMissionsEmptyState;
